module.exports = __webpack_public_path__ + "img/blue-dot.e85a9b03.svg";